interface Legend {
  [key: string]: {
    color: string
    value: number | string
  }[]
}

export const legends: Legend = {
  total_population: [
    {
      color: '#C5D564',
      value: '0-60',
    },
    {
      color: '#DAD14C',
      value: '61-130',
    },
    {
      color: '#EECD34',
      value: '130-199',
    },
    {
      color: '#FCC423',
      value: '200-299',
    },
    {
      color: '#F9891A',
      value: '301-399',
    },
    {
      color: '#F14C11',
      value: '>= 400',
    },
  ],
  total_population_most_represented_age: [
    {
      color: '#C5D564',
      value: '0-19',
    },
    {
      color: '#DAD14C',
      value: '20-39',
    },
    {
      color: '#FCC423',
      value: '40-64',
    },
    {
      color: '#F9891A',
      value: '65-79',
    },
    {
      color: '#F14C11',
      value: '80+',
    },
  ],
  total_population_most_represented_households_number: [
    {
      color: '#C5D564',
      value: 1,
    },
    {
      color: '#DAD14C',
      value: 2,
    },
    {
      color: '#EECD34',
      value: 3,
    },
    {
      color: '#FCC423',
      value: 4,
    },
    {
      color: '#F9891A',
      value: 5,
    },
    {
      color: '#F14C11',
      value: '>= 6',
    },
  ],
  total_population_most_represented_residents_city_time: [
    {
      color: '#C5D564',
      value: '0-1',
    },
    {
      color: '#EECD34',
      value: '1-5',
    },
    {
      color: '#F9891A',
      value: '6-10',
    },
    {
      color: '#F14C11',
      value: '>= 10',
    },
  ],
  number_residents_city_0_1_year: [
    {
      color: '#C5D564',
      value: '0-9',
    },
    {
      color: '#DAD14C',
      value: '10-29',
    },
    {
      color: '#EECD34',
      value: '30-59',
    },
    {
      color: '#FCC423',
      value: '60-89',
    },
    {
      color: '#F9891A',
      value: '90-149',
    },
    {
      color: '#F14C11',
      value: '>= 150',
    },
  ],
}
